import { jsx as _jsx } from "react/jsx-runtime";
import { IconButtonContainer } from "./styled";
import { Icon } from "../Icon";
export const IconButton = ({ icon, size, active, onClick }) => {
    return (_jsx(IconButtonContainer, { active: active, onClick: onClick, children: _jsx(Icon, { icon: icon, size: size ?? 12 }) }));
};
